import { Toast } from "mint-ui";
import xhr from "./xhr";
import * as storage from "./storage";
import * as session from "./session";
import Moba from "./moba";
import Http from "./http";

const userAgent = window.navigator.userAgent;

const isApp = (() => {
  if (/IFFamilyFarm/i.test(userAgent)) {
    return true;
  }
  return false;
})();

// 是否在微信内
const isWX = (() => {
  return /MicroMessenger/i.test(userAgent);
})();

// 是否在QQ内
const isQQ = (() => {
  return /qq/i.test(userAgent) && !isWX && !isApp;
})();

// 获得当前URL参数
function getUrlParams(url = window.top.location.search) {
  let tmpArr = [];
  const params = {};
  const urlArr = url.split("?");
  if (urlArr.length > 1) {
    tmpArr = urlArr[1].split("#")[0].split("&");
  }
  if (tmpArr.length > 0 && tmpArr[0] !== "") {
    tmpArr.forEach(item => {
      const tmp = item.split("=");
      params[tmp[0]] = tmp[1];
    });
  }
  return params;
}

// 获取当前用户语音
const userLang = (() => {
  let lang = navigator.language || navigator.userLanguage; //常规浏览器语言和IE浏览器
  lang = lang.substr(0, 2); //截取lang前2位字符
  let urlParams = getUrlParams();
  if (urlParams.lang) {
    lang = urlParams.lang;
  }
  return lang;
})()

// 正则
const reg = {
  email: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/, // 邮箱
  password: /^(\d|\w|\W){6,15}$/ // 6-15数字、字母
};

// toast 提醒，默认底部
function toast(message = "", opt = {}) {
  Toast({
    message,
    position: "bottom",
    duration: 3000,
    ...opt
  });
}

// 平方米 转 公顷
function unitsMtoAcre(m = 0) {
  return (m / 10000)
    .toFixed(2)
    .replace(/(\d{3})/g, "$1 ")
    .replace(/\s*$/, "");
}

// 米 转 千米
function unitsMtoKm(m = 0) {
  return (m / 1000).toFixed(2);
}

export { Moba, Http, isApp, isWX, isQQ, userLang, getUrlParams, xhr, storage, session, reg, toast, unitsMtoAcre, unitsMtoKm };
